import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, Lock, Eye, Database } from 'lucide-react';

export const PolitiqueConfidentialite = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-br from-black via-gray-900 to-black text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center space-x-2 text-gray-300 hover:text-white mb-8 transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Retour au site</span>
          </button>
          <h1 className="text-4xl md:text-5xl font-bold">Politique de Confidentialité</h1>
          <p className="text-gray-300 mt-4">Protection de vos données personnelles</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
          
          {/* Introduction */}
          <section>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Le Client est informé des réglementations concernant la communication marketing, la loi du 21 Juin 2014 pour la confiance dans l'Economie Numérique, 
                la Loi Informatique et Liberté du 06 Août 2004 ainsi que du Règlement Général sur la Protection des Données (RGPD : n° 2016-679).
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Responsables de la collecte */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <Shield className="mr-3 text-blue-600" size={28} />
              7.1 Responsables de la collecte des données personnelles
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Pour les Données Personnelles collectées dans le cadre de la création du compte personnel de l'Utilisateur et de sa navigation sur le Site, 
                le responsable du traitement des Données Personnelles est : <strong>K&O PHONELAB</strong>. K&O PHONELAB est représenté par <strong>Ouahcene AIT CHIKOUNE</strong>, son représentant légal.
              </p>
              <p>
                En tant que responsable du traitement des données qu'il collecte, K&O PHONELAB s'engage à respecter le cadre des dispositions légales en vigueur. 
                Il lui appartient notamment au Client d'établir les finalités de ses traitements de données, de fournir à ses prospects et clients, 
                à partir de la collecte de leurs consentements, une information complète sur le traitement de leurs données personnelles et de maintenir un registre 
                des traitements conforme à la réalité.
              </p>
              <p>
                Chaque fois que K&O PHONELAB traite des Données Personnelles, K&O PHONELAB prend toutes les mesures raisonnables pour s'assurer de l'exactitude 
                et de la pertinence des Données Personnelles au regard des finalités pour lesquelles K&O PHONELAB les traite.
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Finalité des données collectées */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <Database className="mr-3 text-blue-600" size={28} />
              7.2 Finalité des données collectées
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                K&O PHONELAB est susceptible de traiter tout ou partie des données :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>pour permettre la navigation sur le Site et la gestion et la traçabilité des prestations et services commandés par l'utilisateur : données de connexion et d'utilisation du Site, facturation, historique des commandes, etc.</li>
                <li>pour prévenir et lutter contre la fraude informatique (spamming, hacking…) : matériel informatique utilisé pour la navigation, l'adresse IP, le mot de passe (hashé)</li>
                <li>pour améliorer la navigation sur le Site : données de connexion et d'utilisation</li>
                <li>pour mener des enquêtes de satisfaction facultatives : adresse email</li>
                <li>pour mener des campagnes de communication (sms, mail) : numéro de téléphone, adresse email</li>
              </ul>
              <p className="font-semibold text-gray-900 mt-4">
                K&O PHONELAB ne commercialise pas vos données personnelles qui sont donc uniquement utilisées par nécessité ou à des fins statistiques et d'analyses.
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Droit d'accès, de rectification et d'opposition */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <Eye className="mr-3 text-blue-600" size={28} />
              7.3 Droit d'accès, de rectification et d'opposition
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Conformément à la réglementation européenne en vigueur, les Utilisateurs de K&O PHONELAB disposent des droits suivants :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>droit d'accès (article 15 RGPD) et de rectification (article 16 RGPD), de mise à jour, de complétude des données des Utilisateurs</li>
                <li>droit de verrouillage ou d'effacement des données des Utilisateurs à caractère personnel (article 17 du RGPD), lorsqu'elles sont inexactes, incomplètes, équivoques, périmées, ou dont la collecte, l'utilisation, la communication ou la conservation est interdite</li>
                <li>droit de retirer à tout moment un consentement (article 13-2c RGPD)</li>
                <li>droit à la limitation du traitement des données des Utilisateurs (article 18 RGPD)</li>
                <li>droit d'opposition au traitement des données des Utilisateurs (article 21 RGPD)</li>
                <li>droit à la portabilité des données que les Utilisateurs auront fournies, lorsque ces données font l'objet de traitements automatisés fondés sur leur consentement ou sur un contrat (article 20 RGPD)</li>
                <li>droit de définir le sort des données des Utilisateurs après leur mort et de choisir à qui K&O PHONELAB devra communiquer (ou non) ses données à un tiers qu'ils aura préalablement désigné</li>
              </ul>
              <p className="mt-4">
                Dès que K&O PHONELAB a connaissance du décès d'un Utilisateur et à défaut d'instructions de sa part, K&O PHONELAB s'engage à détruire ses données, 
                sauf si leur conservation s'avère nécessaire à des fins probatoires ou pour répondre à une obligation légale.
              </p>
              <p className="mt-4">
                Si l'Utilisateur souhaite savoir comment K&O PHONELAB utilise ses Données Personnelles, demander à les rectifier ou s'oppose à leur traitement, 
                l'Utilisateur peut contacter K&O PHONELAB par écrit à l'adresse suivante :
              </p>
              <div className="bg-blue-50 p-6 rounded-lg mt-4">
                <p className="font-semibold text-gray-900">K&O PHONELAB – DPO, KOPHONELAB</p>
                <p>5 rue Paul Verlaine 69100 Villeurbanne</p>
              </div>
              <p className="mt-4">
                Dans ce cas, l'Utilisateur doit indiquer les Données Personnelles qu'il souhaiterait que K&O PHONELAB corrige, mette à jour ou supprime, 
                en s'identifiant précisément avec une copie d'une pièce d'identité (carte d'identité ou passeport).
              </p>
              <p className="mt-4">
                Les demandes de suppression de Données Personnelles seront soumises aux obligations qui sont imposées à K&O PHONELAB par la loi, 
                notamment en matière de conservation ou d'archivage des documents. Enfin, les Utilisateurs de K&O PHONELAB peuvent déposer une réclamation 
                auprès des autorités de contrôle, et notamment de la CNIL (<a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://www.cnil.fr/fr/plaintes</a>).
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Non-communication des données */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <Lock className="mr-3 text-blue-600" size={28} />
              7.4 Non-communication des données personnelles
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                K&O PHONELAB s'interdit de traiter, héberger ou transférer les Informations collectées sur ses Clients vers un pays situé en dehors de l'Union européenne 
                ou reconnu comme « non adéquat » par la Commission européenne sans en informer préalablement le client. Pour autant, K&O PHONELAB reste libre du choix 
                de ses sous-traitants techniques et commerciaux à la condition qu'il présentent les garanties suffisantes au regard des exigences du 
                Règlement Général sur la Protection des Données (RGPD : n° 2016-679).
              </p>
              <p>
                K&O PHONELAB s'engage à prendre toutes les précautions nécessaires afin de préserver la sécurité des Informations et notamment qu'elles ne soient pas 
                communiquées à des personnes non autorisées. Cependant, si un incident impactant l'intégrité ou la confidentialité des Informations du Client est portée 
                à la connaissance de K&O PHONELAB, celle-ci devra dans les meilleurs délais informer le Client et lui communiquer les mesures de corrections prises. 
                Par ailleurs K&O PHONELAB ne collecte aucune « données sensibles ».
              </p>
              <p>
                Les Données Personnelles de l'Utilisateur peuvent être traitées par des filiales de K&O PHONELAB et des sous-traitants (prestataires de services), 
                exclusivement afin de réaliser les finalités de la présente politique.
              </p>
              <p>
                Dans la limite de leurs attributions respectives et pour les finalités rappelées ci-dessus, les principales personnes susceptibles d'avoir accès 
                aux données des Utilisateurs de K&O PHONELAB sont principalement les agents de notre service client.
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Notification d'incident */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              8. Notification d'incident
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Quels que soient les efforts fournis, aucune méthode de transmission sur Internet et aucune méthode de stockage électronique n'est complètement sûre. 
                Nous ne pouvons en conséquence pas garantir une sécurité absolue.
              </p>
              <p>
                Si nous prenions connaissance d'une brèche de la sécurité, nous avertirions les utilisateurs concernés afin qu'ils puissent prendre les mesures appropriées. 
                Nos procédures de notification d'incident tiennent compte de nos obligations légales, qu'elles se situent au niveau national ou européen. 
                Nous nous engageons à informer pleinement nos clients de toutes les questions relevant de la sécurité de leur compte et à leur fournir toutes les informations 
                nécessaires pour les aider à respecter leurs propres obligations réglementaires en matière de reporting.
              </p>
              <p>
                Aucune information personnelle de l'utilisateur du site n'est publiée à l'insu de l'utilisateur, échangée, transférée, cédée ou vendue sur un support quelconque à des tiers. 
                Seule l'hypothèse du rachat de K&O PHONELAB et de ses droits permettrait la transmission des dites informations à l'éventuel acquéreur qui serait à son tour 
                tenu de la même obligation de conservation et de modification des données vis à vis de l'utilisateur du site.
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Sécurité */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Sécurité
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Pour assurer la sécurité et la confidentialité des Données Personnelles et des Données Personnelles de Santé, K&O PHONELAB utilise des réseaux protégés 
                par des dispositifs standards tels que par pare-feu, la pseudonymisation, l'encryption et mot de passe.
              </p>
              <p>
                Lors du traitement des Données Personnelles, K&O PHONELAB prend toutes les mesures raisonnables visant à les protéger contre toute perte, utilisation détournée, 
                accès non autorisé, divulgation, altération ou destruction.
              </p>
            </div>
          </section>

        </div>

        {/* Back to site button */}
        <div className="text-center mt-8">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center space-x-2 bg-black text-white px-8 py-4 rounded-full font-semibold hover:bg-gray-800 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <ArrowLeft size={20} />
            <span>Retour au site</span>
          </button>
        </div>
      </div>
    </div>
  );
};